document.addEventListener('DOMContentLoaded', function() {
  class SearchDrawer extends HTMLElement {
    constructor() {
      super();
      // Gestire la chiusura con il tasto Escape
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      // Gestire la chiusura con il click sull'overlay
      this.querySelector('.drawer__close').addEventListener('click', this.close.bind(this));
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // Inizializzare gli event listener sull'icona di ricerca
      this.initSearchIconListeners();
    }

    initSearchIconListeners() {
      // Trovare tutte le icone di ricerca e assegnare l'event listener
      const searchIcons = document.querySelectorAll('[id*="searchIconHeader"]');
      searchIcons.forEach((icon) => {
        icon.addEventListener('click', this.open.bind(this));
      });
    }

    open() {
      const searchDrawer = document.getElementById('SearchDrawer');
      // Aggiungere le classi animate e active
      setTimeout(() => { searchDrawer.classList.add('animate', 'active'); });

      searchDrawer.addEventListener('transitionend', () => {
        const focusElement = searchDrawer.querySelector('.drawer__inner') || searchDrawer.querySelector('.drawer__close');
        trapFocus(searchDrawer, focusElement);
      }, { once: true });

      // Prevenire lo scrolling del body
      document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
 /*     document.body.classList.add('overflow-hidden'); */
    }

    close() {
      const searchDrawer = document.getElementById('SearchDrawer');
      searchDrawer.classList.remove('active');
      removeTrapFocus(this.activeElement);
  /*    document.body.classList.remove('overflow-hidden'); */
      document.body.style.paddingRight = '';
    }

    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  }

  customElements.define('search-drawer', SearchDrawer);
});

// Assicurati che le funzioni trapFocus e removeTrapFocus siano definite altrove nel tuo script.
